var menuMessagesCount = null;
var menuTasksCount = null;
var menuBadgesCount = null;
var menuRefresh = true;

(function(document, jQuery) {'use strict';

	/**
	 * update the localStorage and the badge icon value
	 * Add new sound in html head => <audio id="message_notification" src="audio/message_notification.mp3" preload="auto"></audio>
	 * @param  {string} id    of the html badge
	 * @param  {integer} total value of the badge
	 * @return {none}
	 */
	function badgeUpdate(id, total) {
		if( typeof(Storage) !== "undefined" ) {
			var old = localStorage.getItem(id);
			if( old != total && total > 0 ) {
				playSoundFor(id);
			}
			// store it
			localStorage.setItem(id, total);
		}
		total = parseInt(total);
		if( total ) {
			$(id).text(total);
			$(id).show();
		}
		else {
			$(id).hide();
		}
	}

	/**
	 * update the localStorage and the badge icon value
	 * @param  {string} id    of the html badge
	 * @param  {integer} total value of the badge
	 * @return {none}
	 */
	function badgeUpdateMenu(id, total) {
		if( typeof(Storage) !== "undefined" ) {
			var old = localStorage.getItem(id);
			localStorage.setItem(id, total);
		}
		total = parseInt(total);
		if( total ) {
			$(id).text(total);
			$(id).show();
		}
		else {
			$(id).hide();
		}
	}

	/**
	 * play a sound for notification
	 * @param  {int} id of the badge
	 * @return {none}
	 */
	function playSoundFor(id) {
		var sound_id = null;

		switch( id ) {
			case '#messages-count':
				sound_id = 'message_notification';
				break;
		}

		if( sound_id ) {
			document.getElementById(sound_id).play();
		}
	}

	jQuery(document).ready(function($) {
		var menu = document.getElementById('menu');
		if( !menu) {
			// there is no menu, do not continue
			return;
		}
		var callDelay   = 2000; // slow old browsers without cache support to avoid DOS
		var refreshRate = 60*1000;
		var path        = window.location.pathname;
		/* IO Socket */
		var io_url     = config && config.io && config.io.url ? config.io.url : null;
		var io_channel = config && config.io && config.io.channel ? config.io.channel : null;
		var socket     = null;
		if( io_url && io_channel ) {
			var socket = io.connect(io_url);
			socket.on(io_channel, function(e) {
				e = $.parseJSON(e);

				if( e.event == "message" ) {
					menuMessagesCount();
				}
			});
		}

		/**
		 * Optimization :
		 *  - display cached badges counts
		 *  - calculate the refresh delay for next call for updating badges
		 */
		if ( typeof(Storage) !== "undefined" ) {
    		// get cached data
    		if( path != '/conversation' ) {
    			badgeUpdate('#messages-count', localStorage.getItem('#messages-count'));
    		}
    		badgeUpdate('#tasks-count', localStorage.getItem('#tasks-count'));
			badgeUpdateMenu('#leads-count', localStorage.getItem('#leads-count'));
			badgeUpdateMenu('#resils-count', localStorage.getItem('#resils-count'));
			badgeUpdateMenu('#sinistres-count', localStorage.getItem('#sinistres-count'));

	        var lastCall = localStorage.getItem('menuRefreshDate');
	        if( lastCall ) {
	        	lastCall = new Date(lastCall);
	        	var now = new Date;
	        	callDelay = now - lastCall;
	        	if( callDelay < 0 || callDelay > refreshRate) {
	        		callDelay = 0;
	        	}
	        }
	    }


	    /**
	     * refresh messages count badge
	     */
		menuMessagesCount = function() {
			if( path == '/conversation' ) {
				// avoid displaying count of messages in this section => limits unnecessary calls
				badgeUpdate('#messages-count', 0);
				return;
			}

			$.ajax({
				url:'/api/notification/count/' + encodeURIComponent("App\\ConversationMessage"),
				success:function(data) {
					badgeUpdate('#messages-count', data.count);
				},
				error:function(error) {
					console.error("Failed to load notifications count, status:" + error.status);
				}
			});
		};

		/**
		 * refresh task badge
		 */
		menuTasksCount = function() {
			$.ajax({
				url:'/api/task/total/todo',
				success:function(data) {
					badgeUpdate('#tasks-count', data.total);
				},
				error:function(error) {
					console.error("Failed to load todo tasks count, status:" + error.status);
				}
			});
		};

		/**
		 * refresh lead badge
		 */
		menuBadgesCount = function(badge) {
			if (badge==undefined) return;
			$.ajax({
				url:'../request/req_menu_badges.php?badge='+badge,
				success:function(data) {
					badgeUpdateMenu('#'+badge+'-count', data);
				},
				error:function(error) {
					badgeUpdateMenu('#'+badge+'-count', 0);
					console.error("Failed to load todo "+badge+" count, status:" + error.status);
				}
			});
		};

		/**
		 * Basic refresh
		 */
		var menuRefresh = function() {
			// Call
			menuMessagesCount();
			menuTasksCount();
			menuBadgesCount('leads');
			menuBadgesCount('resils');
			menuBadgesCount('sinistres');

			if (typeof(Storage) !== "undefined" ) {
				// keep track of last call
				localStorage.setItem('menuRefreshDate', new Date());
			}

			setTimeout(menuRefresh, refreshRate); // call it back later
		};
		setTimeout(menuRefresh, callDelay);
	});

})(document, jQuery);
